import it from './activities.it.json';
import en from './activities.en.json';

const activitiesContent = { it, en };

export default activitiesContent;
